import React, { useState, createContext } from "react";
import { Alert } from "./Alert";

export const AlertContext = createContext({
    alert: () => { }
});

export const AlertContextProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [isError, setIsError] = useState(false);

    const alert = (message, isError) => {
        setMessage(message);
        setIsOpen(true);
        setIsError(isError);
    };

    return (
        <AlertContext.Provider value={{ alert }}>
            <Alert message={message} isOpen={isOpen} isError={isError} onClose={() => setIsOpen(false)} />
            {children}
        </AlertContext.Provider>
    );
};
